export default __webpack_public_path__ + "static/wand-icon.35cee526.png";